import { render, staticRenderFns } from "./UserExtensionAgreement.vue?vue&type=template&id=02c6ad36"
import script from "./UserExtensionAgreement.vue?vue&type=script&lang=js"
export * from "./UserExtensionAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports